module.exports = __webpack_public_path__ + "static/media/Badge.d7262575.png";